import { AppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/AppConfig';
import { getAppConfig } from '@porterin/component-library/src/ts-utils/analytics/fetch-config/FetchConfig';
import { fireApiErrorSentry } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import axios, { AxiosResponse } from 'axios';

import { FareEstimateSecureApiModel } from '../api-models/FareEstimateSecureApiModel';
import { FareEstimateForm } from '../entities/FareEstimateForm';
import { FareEstimateSecure } from '../entities/FareEstimateSecure';
import { FareEstimateSecureError } from '../entities/FareEstimateSecureError';
import { toFareEstimateSecureResponse } from '../entity-mappers/FareEstimateSecureEntityMapper';
import { toFareEstimateSecureError } from '../entity-mappers/FareEstimateSecureErrorMapper';
import { isDesktop } from '../../components/FareEstimateHelper';
import { appendPayloadToUrl } from './FareEstimateValidatorRepo';
import { getLocaleHeaders } from '@porterin/component-library/src/utils/LocaleHelper';

const Config: AppConfig = getAppConfig();
const API_URL = `${Config.oms_url}/fare_estimate_secure`;

function encodePayload(
  form: FareEstimateForm,
  isDesktop: boolean,
): Record<string, string> {
  const {
    pickupAddress,
    dropAddress,
    name,
    mobile,
    requirement,
    serviceCategory,
    geoRegionId,
  } = form;

  return {
    geo_region_id: geoRegionId ?? '3',
    from_address_landmark: pickupAddress.landmark,
    to_address_landmark: dropAddress.landmark,
    from_address_lat: pickupAddress.location.lat.toString(),
    from_address_long: pickupAddress.location.lng.toString(),
    to_address_lat: dropAddress.location.lat.toString(),
    to_address_long: dropAddress.location.lng.toString(),
    customer_name: name,
    customer_mobile: mobile,
    user_type: '/',
    brand: 'porter',
    frequency: requirement,
    service_category: serviceCategory,
    is_device_mobile: isDesktop ? 'false' : 'true',
    source_url: window.location.href,
  };
}

async function submitFareEstimateSecure(
  formData: FareEstimateForm,
): Promise<FareEstimateSecure | FareEstimateSecureError> {
  try {
    const payload = encodePayload(formData, isDesktop());
    const apiUrlWithParams = appendPayloadToUrl(API_URL, payload);
    const response: AxiosResponse<FareEstimateSecureApiModel> =
      await axios.post(
        apiUrlWithParams,
        { re_id: 'Default' },
        {
          headers: { ...getLocaleHeaders() },
        },
      );

    return toFareEstimateSecureResponse(response.data);
  } catch (error: unknown) {
    fireApiErrorSentry(error, 'submitFareEstimateSecure');
    console.log('error', error);
    const maybeData = (error as any).response?.data;
    const errorData = maybeData !== undefined ? maybeData : {};
    return toFareEstimateSecureError(errorData);
  }
}

export { submitFareEstimateSecure };
